const zh_HK = {
    rules: {
        title: '規則',
        content1: `Midafi DAO為全球首創之競選自治匿名DAO組織。

Midafi DAO基於Midafi平臺而創立，其溶入Web3.0網絡，堅守去中心化自治之區塊鏈精神，秉承共建、共治、共亯的原則，立志成為全球最優之元宇宙數位生態共創平臺。

Midafi玩家可以通過MPM進行Midafi的推廣挖礦，通過Midafi Staking進行Midafi的質押挖礦。

在不斷進化陞級的元宇宙中，Midafi將持續拓展新的區塊鏈數位生態，NFT、DID、遊戲、DEX、聚合器……等等都將逐步匯合其中，玩家們以此堆棧，創造孿生於自身的元宇宙數字生活圈； 以此會（匯）友，打造精彩紛呈的數位社交圈。

玩家們本著自主自願自由的精神，以投票形式定期產生Midafi DAO盟主。 盟主任內統籌、協調、服務於玩家，可連選連任，全力推廣Midafi。

玩家投票可於Midafi社區建設基金中獲得激勵收益； 每届盟主則從Midafi社區建設基金中獲取治理援金，用於Midafi的推廣。

玩家投票選舉盟主，盟主服務玩家，選票决定盟主去留。 玩家盟主共生共進，推動Midafi事業蓬勃壯大。

規則：

Midafi社區建設基金：315000枚，Midafi釋放年限100年。

玩家投票激勵：105000枚，2.87枚/天釋放

社區治理援金：105000枚，2.87枚/天釋放

Midafi研發團隊：52500枚，1.43枚/天釋放

Midafi科技團隊：52500枚，1.43枚/天釋放

1、盟主服務治理週期為60+7天，其中7天為投票日。

2、1 Midafi一票，60+7天內可隨投隨撤。

3、盟主治理援金組成：

1）、社區治理援金：Midafi 2.87枚/天釋放。

2）、Midafi質押挖礦消耗Sero能量的20%。

4、盟主職責：

1）、服務Midafi玩家

2）、全力推廣Midafi

5、玩家投票激勵收益按Midafi2.87枚/日加權平均分配釋放至玩家投票帳號，投票撤回後該帳號的激勵收益即停止釋放。

6、系統程式碼開源，數據上鏈，去中心化記帳，沒有後門，不可篡改，自動運行，自動分發。

7、系統公開合約規則，玩家可在無推薦人的情况下主動參與。

8、合約開源地址：GitHub page：`,
        content2: `

Gitee page: `,
        content3: `

Netlify page: `,
        content4: `
        
9、合約地址：`,
        content5: `

10、Midafi銷毀地址：`,
    },
    language: '語言',
    changeToWallet: '切換到',
    changeToLang: 'Switch to',
    tip: {
        addrCopied: '地址已複製',
    },
    button: {
        wallet: '錢包帳戶',
        winnerRewards: '可領取獎勵',
        totalSupply: '總量',
        circulation: '流通量',
        marketingBalance: '推廣待挖量',
        stakingBalance: '質押待挖量',
        fundBalance: '基金待放量',
        destroyAddress: '銷毀地址',
        destroyedBalance: '銷毀總量',

        votes: '數量',
        candidate: '被選舉地址',

        winner: '盟主',
        vote: '投票',
        voted: '已投數量',
        rewards: '投票激勵',
        totalVotes: '總投票數量',

        lastVotes: '上期票數',
        lastWinner: '被選舉地址',
    },
    days: '天',
    header: {
        rank: '排名',
        votes: '票數',
        candidate: '被選舉地址',
    },
    images: {
        switch: '',
        withdraw: '',
    },
    imageLocation: 'cn',
    riskWarning: '自由參與 風險自控',
    changeWallet: {
        title: '切換賬戶',
        content: '確定要切換賬戶嗎？',
        ok: '確定'
    },
}
export default zh_HK;